import type { FC } from 'react'
import type { MultiChartTooltipProps } from './types'
import clsx from 'clsx'
import { Typography } from '@sylveraio/design-system'
import Circle from '@sylveraio/untitled-ui-icons-react/build/esm/Circle'
import { formatTooltipValue } from '../utils/formatTooltipValue'
import orderBy from 'lodash/orderBy'

export const MultiChartTooltip: FC<MultiChartTooltipProps> = ({
  x,
  y,
  xAlign,
  title,
  dataPoints,
  opacity,
  tickFormat,
}) => (
  <div
    className={clsx(
      'absolute mt-2 transform px-2 min-w-max transition pointer-events-none',
      {
        '-translate-x-full': xAlign === 'right',
      },
    )}
    style={{
      left: x,
      top: y,
      opacity,
    }}
  >
    <div className="space-y-0.25 z-50 space-y-1 rounded-lg border border-new-palette-forest-1000 bg-new-palette-forest-900 p-3">
      <Typography
        size="xs"
        className="text-new-palette-neutral-100"
        weight="semibold"
      >
        {title}
      </Typography>
      {orderBy(dataPoints, 'value', 'desc').map(
        ({ datasetColor, datasetLabel, value }) => {
          return (
            <div
              key={`legend-item-${datasetLabel}`}
              className="flex items-center justify-between space-x-4 space-y-0.5"
            >
              <div className="flex items-center space-x-2">
                <Circle
                  className="h-2 w-2"
                  style={{
                    fill: datasetColor,
                  }}
                  strokeOpacity={0}
                />
                <Typography size="xs" className="text-default-on-dark">
                  {datasetLabel}
                </Typography>
              </div>
              <Typography
                className="tabular-nums text-default-on-dark"
                size="xs"
              >
                {formatTooltipValue(value, tickFormat)}
              </Typography>
            </div>
          )
        },
      )}
    </div>
  </div>
)
